angular.module('dnecom')
    .controller('ProductProcessSalesTermsController', ["$scope", "ProductUploadUtils", function ProductProcessSalesTermsController($scope, ProductUploadUtils) {
        // Button style - Custom
        var buttonCustomDefaults = {
            title: 'ADD TO CART',
            styles: {
                fontFamily: 'Helvetica Neue',
                fontSize: '18',
                fontStyle: 'normal',
                fontWeight: 'normal',
                background: '#ffb21c',
                color: '#ffffff',
                borderRadius: '2',
                borderStyle: 'none',
                borderWidth: '1',
                borderColor: '#000000'
            }
        };

        $scope.recentlyUsedButtons = {
            popover: false,
            styles: TemplateData.value('recentlyUsedButtons')
        };

        $scope.buttonTypeTooltip = {
            'button_1': 'Light "Add to Cart" button',
            'button_2': 'Dark "Add to Cart" button',
            'button_3': 'Bright "Add to Cart" button',
            'button_4': 'Soft "Add to Cart" button'
        };

        $scope.autoresponderLists = [];
        var tAList = TemplateData.value('autoresponderLists');
        if (tAList !== null && _.isArray(tAList)) {
            jQuery.each(tAList, function(idx, list){
                list.id = '' + list.id; // need this, because ui-select compare this int values with string value in model
                $scope.autoresponderLists.push(list);
            });
        }

        $scope.autoresponderType = TemplateData.value('autoresponderType');
        $scope.urlUploadBtnText = 'Upload from url';
        $scope.products = {};

        jQuery.each(TemplateData.value('products'), function(idx, product){
            $scope.products[product.id] = product.name;
        });

        $scope.productIds = Object.keys($scope.products);

        // Set default button styles
        if (!$scope.product.properties.salesTerms.customButton) {
            $scope.product.properties.salesTerms.customButton = buttonCustomDefaults;
        }

        $scope.setTimerType = function(type) {
            $scope.product.properties.timer.type = type;

            if (type != 'none' && !$scope.product.properties.timer.action) {
                $scope.product.properties.timer.action = 'remove';
            }
        };

        $scope.updateTimerDuration = function() {
            var timerDateString = moment(
                $scope.product.properties.timer.date + ' ' + $scope.product.properties.timer.time + ' ' + $scope.product.properties.timer.suffix,
                'MM/DD/YYYY hh:mm a'
            ).format('YYYY-MM-DD HH:mm:ss');

            var targetDate = moment.tz(timerDateString, $scope.store.timezone);
            var currentDate = moment.tz($scope.store.timezone);

            var targetDateDuration = moment.duration(targetDate.diff(currentDate));

            if (!$scope.product.properties.timer.repeatDuration) {
                $scope.product.properties.timer.repeatDuration = {};
            }

            $scope.product.properties.timer.repeatDuration.days = targetDateDuration.days();
            $scope.product.properties.timer.repeatDuration.hours = targetDateDuration.hours();
            $scope.product.properties.timer.repeatDuration.minutes = targetDateDuration.minutes();
        };

        var beforeImageUpload = function() {
            $scope.urlUploadBtnText = 'Uploading...';
            $scope.urlUploading = true;
        };

        var afterImageUpload = function() {
            $scope.urlUploadBtnText = 'Upload from url';
            $scope.urlUploading = false;
        };

        $scope.upload = function (file, parentField, field) {
            beforeImageUpload();

            ProductUploadUtils.upload($scope.store, file, function (media) {
                ProductUploadUtils.setProductFieldValue($scope.product, parentField, field, media.id);

                $scope.product.buttonMedia = media;

                afterImageUpload();
            });
        };

        $scope.uploadFromUrl = function (url, parentField, field) {
            beforeImageUpload();

            ProductUploadUtils.uploadUrl($scope.store, url, function (media) {
                ProductUploadUtils.setProductFieldValue($scope.product, parentField, field, media.id);

                $scope.product.buttonMedia = media;
            }).finally(afterImageUpload);
        };

        $scope.normalizeBtnStyles = function (buttonStyles) {
            var styles = angular.copy(buttonStyles);

            // Append 'px'
            styles.fontSize += 'px';
            styles.borderRadius += 'px';
            styles.borderWidth += 'px';

            return styles;
        };

        $scope.closeRecentlyUsedButtonsPopover = function (style) {
            $scope.product.properties.salesTerms.customButton = angular.copy(style);
            $scope.recentlyUsedButtons.popover = false;
        };

        $scope.openRecentlyUsedButtonsPopover = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.recentlyUsedButtons.popover = !$scope.recentlyUsedButtons.popover;
        };

        angular.element(window).click(function () {
            if ($scope.recentlyUsedButtons.popover) {
                $scope.recentlyUsedButtons.popover = false;
                $scope.$digest();
            }
        });

        if (!$scope.product.properties.salesTerms.quantityBarQuantity) {
            ProductUploadUtils.setProductFieldValue($scope.product, 'salesTerms', 'quantityBarQuantity', 15);
        }

        if (!$scope.product.properties.salesTerms.quantityTimer) {
            ProductUploadUtils.setProductFieldValue($scope.product, 'salesTerms', 'quantityTimer', { minutes: 1, seconds: 0 });
        }

        if (!$scope.product.properties.salesTerms.paymentBadgesDisabled) {
            ProductUploadUtils.setProductFieldValue($scope.product, 'salesTerms', 'paymentBadgesDisabled', '0');
        }

        if (!$scope.product.properties.salesTerms.paymentBadgesDisabled) {
            ProductUploadUtils.setProductFieldValue($scope.product, 'salesTerms', 'paymentBadgesDisabled', '0');
        }
    }]);
